var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBooks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12070_301473)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4781 12.1588L12.4038 2.29634C12.3769 2.16737 12.3249 2.04497 12.2506 1.93617C12.1763 1.82737 12.0813 1.73432 11.9709 1.66236C11.8606 1.59041 11.7371 1.54096 11.6076 1.51687C11.4781 1.49277 11.3451 1.49451 11.2163 1.52197L8.29062 2.15072C8.03184 2.20738 7.8059 2.36393 7.66194 2.58631C7.51798 2.80869 7.46764 3.07892 7.52187 3.33822L9.59625 13.2007C9.64248 13.4257 9.76477 13.628 9.94255 13.7734C10.1203 13.9189 10.3428 13.9987 10.5725 13.9995C10.6435 13.9994 10.7143 13.9918 10.7837 13.977L13.7094 13.3482C13.9685 13.2914 14.1946 13.1346 14.3386 12.9118C14.4826 12.689 14.5327 12.4184 14.4781 12.1588ZM8.5 3.13384C8.5 3.13009 8.5 3.12822 8.5 3.12822L11.425 2.50322L11.6331 3.49509L8.70813 4.12447L8.5 3.13384ZM9.125 6.09509L8.91562 5.10134L11.8419 4.47259L12.0506 5.46634L9.125 6.09509ZM13.5 12.3707L10.575 12.9957L10.3669 12.0038L13.2919 11.3745L13.5 12.3651C13.5 12.3688 13.5 12.3707 13.5 12.3707ZM6.5 1.99947H3.5C3.23478 1.99947 2.98043 2.10483 2.79289 2.29236C2.60536 2.4799 2.5 2.73425 2.5 2.99947V12.9995C2.5 13.2647 2.60536 13.519 2.79289 13.7066C2.98043 13.8941 3.23478 13.9995 3.5 13.9995H6.5C6.76522 13.9995 7.01957 13.8941 7.20711 13.7066C7.39464 13.519 7.5 13.2647 7.5 12.9995V2.99947C7.5 2.73425 7.39464 2.4799 7.20711 2.29236C7.01957 2.10483 6.76522 1.99947 6.5 1.99947ZM3.5 2.99947H6.5V3.99947H3.5V2.99947ZM6.5 12.9995H3.5V11.9995H6.5V12.9995Z",
    fill: "#B5B5BC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12070_301473"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooks);
export default __webpack_public_path__ + "static/media/books.c7c843de4b2141efe034c96542ad96bc.svg";
export { ForwardRef as ReactComponent };